"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDateTimeRemote = exports.getDateTimeClient = exports.getDateTime = exports.DATE_TIME_SRC_REMOTE = exports.DATE_TIME_SRC_CLIENT = void 0;
var _date = require("./type-checks/date");
var _function = require("./type-checks/function");
var _object = require("./type-checks/object");
var _string = require("./type-checks/string");
var _common = require("../config/common");
const DATE_TIME_SRC_CLIENT = exports.DATE_TIME_SRC_CLIENT = "client";
const DATE_TIME_SRC_REMOTE = exports.DATE_TIME_SRC_REMOTE = "remote";

/**
 * Gets the current datetime from the local client
 *
 * @name getDateTimeClient
 * @returns {String} Datetime value
 */
const getDateTimeClient = () => {
  return new Date().getTime();
};

/**
 * Gets the current datetime from remote client asyncronously
 *
 * @name getDateTimeRemote
 * @param {String} URL of server providing time
 * @param {Object} [requestConfig = {}] Optional configuration properties
 * @returns {Promise<string>} returns datetime
 */
exports.getDateTimeClient = getDateTimeClient;
const getDateTimeRemote = async function (url) {
  let requestConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let dateTime = null;
  try {
    const {
      headers
    } = await fetch(url, {
      method: "GET",
      ...requestConfig
    });
    dateTime = (0, _object.isObject)(headers) && (0, _function.isFunction)(headers.get) ? headers.get(_common.HEADER_KEY_DATE) : dateTime;
    dateTime = (0, _string.isStringOfLength)(dateTime) ? new Date(dateTime) : dateTime;
    dateTime = (0, _date.isDate)(dateTime) ? dateTime.getTime() : null;
  } catch (e) {
    dateTime = null;
  }
  return dateTime;
};
exports.getDateTimeRemote = getDateTimeRemote;
const getDateTime = async dateTimeSrc => {
  if (dateTimeSrc === DATE_TIME_SRC_CLIENT) {
    return getDateTimeClient();
  } else {
    return await getDateTimeRemote(_common.URL_PUBLIC_PING);
  }
};
exports.getDateTime = getDateTime;